import { schema, normalize } from 'normalizr';
import { createAction, createSlice, createSelector } from '@reduxjs/toolkit';

// Actions
export const fetchDocsReceived = createAction('secureShare/fetchDocsReceived');

export const fetchDocsSent = createAction('secureShare/fetchDocsSent');

export const putSecureShareDoc = createAction('secureShare/putSecureShareDoc');

export const fetchExternalContacts = createAction('secureShare/fetchExternalContacts');

export const postExternalContact = createAction('secureShare/postExternalContact');

export const putExternalContact = createAction('secureShare/putExternalContact');

// Selectors

export const externalContactsSelector = createSelector(
  (state) => state.secureShare.externalContacts,
  (subState) => Object.keys(subState).map((key) => subState[key]),
);

export const receivedDocsFolderSelector = createSelector(
  (state) => state.secureShare.received.folders,
  (subState) => Object.keys(subState).map((key) => subState[key]),
);

export const normalizedReceivedFoldersSelector = createSelector(
  (state) => state.secureShare.received.folders,
  (subState) => subState,
);

export const normalizedReceivedDocsSelector = createSelector(
  (state) => state.secureShare.received.docs,
  (subState) => subState,
);

export const normalizedSentDocsSelector = createSelector(
  (state) => state.secureShare.sent.docs,
  (subState) => subState,
);

const secureShareDocSchema = new schema.Entity('docs');
const foldersSchema = new schema.Entity('folders', {
  secureShareDocs: [secureShareDocSchema],
});

const initialState = {
  externalContacts: {},
  received: {
    folders: {},
    docs: {},
  },
  sent: {
    docs: {},
  },
};
const secureShareSlice = createSlice({
  name: 'secureShare',
  initialState,
  reducers: {
    fetchDocsReceivedSuccess(state, action) {
      const { data } = action.payload;
      const {
        entities: { folders = {}, docs = {} },
      } = normalize(data, [foldersSchema]);
      state.received.folders = folders;
      state.received.docs = docs;
    },
    fetchDocsSentSuccess(state, action) {
      const { data } = action.payload;
      const {
        entities: { docs = {} },
      } = normalize(data, [secureShareDocSchema]);
      state.sent.docs = docs;
    },
    fetchExternalContactsSuccess(state, action) {
      const { data } = action.payload;
      data.forEach((contact) => {
        const { id } = contact;
        state.externalContacts[id] = contact;
      });
    },
    putSecureShareDocSuccess(state, action) {
      const { data, type, folderId, unreadCount } = action.payload;
      if (folderId && unreadCount) {
        state.received.folders[folderId].unreadCount = unreadCount;
      }
      state[type].docs[data.id] = data;
    },
    postExternalContactSuccess(state, action) {
      const { data } = action.payload;
      state.externalContacts[data.id] = data;
    },
    putExternalContactSuccess(state, action) {
      const { data } = action.payload;
      state.externalContacts[data.id] = data;
    },
  },
});

export const {
  fetchDocsReceivedSuccess,
  fetchExternalContactsSuccess,
  fetchDocsSentSuccess,
  putExternalContactSuccess,
  putSecureShareDocSuccess,
  postExternalContactSuccess,
} = secureShareSlice.actions;

export default secureShareSlice.reducer;
